import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { Chatbot } from "../types";
import { extractErrorMessageFromResponse, isTemplateChatbotId } from "../utils";

import { getSubpathBridgeClientFetch } from "@zapier/identity/client/fetch";

// Create authenticated client for a specific service
const chatbotsClient = getSubpathBridgeClientFetch("chatbots");

export const fetchChatbotAtomFamily_SUSPENDS = atomFamily(
  (chatbotId: string | undefined) => {
    const chatbotAtom = atom(async () => {
      if (!chatbotId) {
        return;
      }

      const isTemplateChatbot = isTemplateChatbotId(chatbotId);

      // Because we don't want to fetch with template asset id and get a 400 Bad Request error
      if (isTemplateChatbot) {
        return;
      }

      try {
        const res = await chatbotsClient(
          `/api/chatbots/v0/chatbots/${chatbotId}`,
        );

        if (res.ok) {
          const { data: chatbot } = await res.json();
          return { type: "success", data: chatbot as Chatbot };
        }

        /* ----- expected error codes we surface to UI ----- */
        if (res.status === 404) {
          return { type: "not_found" };
        }
        if (res.status === 403) {
          return { type: "forbidden" };
        }

        /* ----- 5xx or other unexpected errors – log & degrade ----- */
        const errorMessage = await extractErrorMessageFromResponse(res);
        console.error(`Failed to fetch chatbot ${chatbotId}: ${errorMessage}`);
        return null;
      } catch (error) {
        console.error("Network error fetching chatbot:", error);
        // Network/unknown error – return null so UI can degrade gracefully
        return null;
      }
    });

    chatbotAtom.debugLabel = `fetchChatbotAtomFamily_SUSPENDS(${chatbotId})`;
    return chatbotAtom;
  },
);
